import * as React from 'react';
import * as _ from 'underscore';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { LicensesService } from '../../../ts/services/LicensesService';
import { BreadcrumbStateInfo } from '../../content/breadcrumbs/BreadcrumbStateInfo';
import { ServerUrls } from '../../ServerUrls';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { LicenseInfoBar } from '../Header/LicenseInfoBar';
import { SpaceHeaderWithTotalItemsCount } from '../Header/SpaceHeaderWithTotalItemsCount';

export interface AllServerUsersSpaceOwnProps extends ReactDirectiveProps {}

export interface AllServerUsersAngularProps {
  readonly licensesService: LicensesService;
}

export interface AllServerUsersSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedUsers: number;
}

export interface AllServerUsersSpaceDispatchProps {
  readonly addServerUsers: () => void;
  readonly requestSpaceContents: () => void;
  readonly updateBreadcrumbs: (breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>) => void;
}

export type AllServerUsersSpaceProps = AllServerUsersSpaceOwnProps & AllServerUsersAngularProps & AllServerUsersSpaceStateProps & AllServerUsersSpaceDispatchProps;

export class AllServerUsersSpace extends React.PureComponent<AllServerUsersSpaceProps> {
  public constructor(props: AllServerUsersSpaceProps) {
    super(props);
  }

  public componentDidMount() {
    this.props.updateBreadcrumbs([getServerUsersSpaceBreadcrumb()]);
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverUsers()});
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.serverUsers()}
          testId={'server-users'}
          count={this.props.numberOfFetchedUsers}
          countUpToDate={!this.props.isBusyFetchingItems}
          licenseInfoBar={this.licenseBar}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: this.addUsersButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.usersEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private licenseBar = (): JSX.Element => {
    return <LicenseInfoBar
      hasSiteLicensingInfo={false}
      licensesService={this.props.licensesService}
    />;
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  }

  private addUsersButton = (): JSX.Element => {
    const handleClick = () => this.props.addServerUsers();
    return (
      <ButtonWidget
        children={Messages.addUsers()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        tb-test-id={'action-add-users'}
        testId={'action-add-users'}
      />
    );
  }
}

export function getServerUsersSpaceBreadcrumb(): BreadcrumbStateInfo {
  const serverUrls = ServerUrls.getInstance();
  return {
    id: serverUrls.usersUrl(),
    text: Messages.allServerUsers(),
    href: serverUrls.usersUrl(),
    testId: 'server-users-link'
  };
}
